class QuoteSlider {
  constructor(el) {

    if (!el) return

    this._bind();

    this.dom = {
      el: el,
      right: el.querySelector(".right"),

      images: el.querySelectorAll(".image"),
      text: el.querySelectorAll(".text"),
      quotes: el.querySelectorAll(".quote"),
      captions: el.querySelectorAll(".caption"),

      leftTrigger: el.querySelector(".left-trigger"),
      rightTrigger: el.querySelector(".right-trigger"),

      dots: el.querySelectorAll(".dot")
    }

    this.data = {
      cur: 0,
      last: 0,
      z: 2,
      max: this.dom.images.length - 1,
      isTransitioning: false,
    }

    this.pos = {
      start: {
        x: null,
        y: null,
      },
      cur: {
        x: null,
        y: null,
      }
    }
    
    this.modify = (getViewport().width > 768) ? this.dom.text.length/2 : 0;
    this.swipeThreshold = 15;

    // this.setHeight();
    this._addEvents();
  }

  _bind() {
    ['next', 'prev', 'updateDots', 'touchstart', 'touchmove',]
      .forEach(fn => this[fn] = this[fn].bind(this));
  }

  setHeight() {
    let maxHeight = 0
    this.dom.quotes.forEach(quote => {
      let bcr = quote.getBoundingClientRect()
      if (bcr.height > maxHeight) {
        maxHeight = bcr.height;
      }
    })

    let wrapper = this.dom.el.querySelector(".quote-wrapper")
    let margin = getViewport().width > 768 ? 43 : 72

    if (!wrapper) return
    wrapper.style.height = maxHeight + margin + "px";
  }

  _addEvents() {
    this.dom.rightTrigger.addEventListener("click", this.next, false);
    this.dom.leftTrigger.addEventListener("click", this.prev, false);
    this.dom.dots.forEach((dot, i) => {
      dot.addEventListener("click", () => { this.clickDot(i) }, false);
    });

    this.dom.right.addEventListener("touchstart", this.touchstart)
    this.dom.right.addEventListener("touchmove", this.touchmove)
  }

  touchstart(e) {
    if (!e.touches) return

    this.pos.start.x = this.pos.cur.x = e.touches[0].pageX;
    this.pos.start.y = this.pos.cur.y = e.touches[0].pageY;
  }

  touchmove(e) {
    if (!e.touches) return

    this.pos.cur.x = e.touches[0].pageX;
    this.pos.cur.y = e.touches[0].pageY;

    let distX = this.pos.start.x - this.pos.cur.x;
    let distY = this.pos.start.y - this.pos.cur.y;

    if (Math.abs(distY) > 8) return

    if (distX > this.swipeThreshold) {
      this.next()

      this.pos.start.x = this.pos.cur.x;
      this.pos.start.y = this.pos.cur.y;
    } else if (distX < -this.swipeThreshold) {
      this.prev();

      this.pos.start.x = this.pos.cur.x;
      this.pos.start.y = this.pos.cur.y;
    }
  }

  next(index) {
    if (this.data.isTransitioning) return

    this.data.isTransitioning = true;

    this.data.z += 1;

    if (Number.isInteger(index)) {
      this.data.cur = index;
    } else {
      this.data.cur += 1;
      if (this.data.cur > this.data.max) this.data.cur = 0;
    }

    this.dom.images.forEach((image, i) => {
      if (i !== this.data.last && i !== this.data.cur) gsap.set(image, { opacity: 0 });
    });


    let imgDur = getViewport().width < 768 ? 1.15 : 1.4;
    let tl = new gsap.timeline();

    // Image Animation
    tl.fromTo(this.dom.images[this.data.cur], imgDur,
      { scale: 1.2, xPercent: 100, zIndex: this.data.z, rotate: 40, opacity: 1 },
      { scale: 1, xPercent: 0, zIndex: this.data.z, rotate: 0, transformOrigin: "0% 100%", ease: Expo.easeInOut })
    tl.to(this.dom.images[this.data.last], imgDur, { xPercent: -50, rotate: -15, transformOrigin: "0% 0%", ease: Expo.easeInOut }, "<0.1")

    tl.to(this.dom.text[this.data.last + this.modify], .8, { autoAlpha: 0, ease: "sine.inOut", }, 0);
    tl.to(this.dom.text[this.data.cur + this.modify], .8, { autoAlpha: 1, ease: "sine.inOut", }, ">-.4");

    // Text Animation
    tl.to(this.dom.quotes[this.data.last], .8, { autoAlpha: 0, ease: "sine.inOut", }, 0);
    tl.to(this.dom.quotes[this.data.cur], .8, { autoAlpha: 1, ease: "sine.inOut", }, ">-.4");

    tl.to(this.dom.captions[this.data.last], .8, { autoAlpha: 0, ease: "sine.inOut", }, 0);
    tl.to(this.dom.captions[this.data.cur], .8, { autoAlpha: 1, ease: "sine.inOut", }, ">-.4");

    tl.add(() => { this.data.isTransitioning = false }, ">-0.3");


    this.updateDots();
    this.data.last = this.data.cur;
  }

  prev(index) {
    if (this.data.isTransitioning) return

    this.data.isTransitioning = true;

    this.data.z += 1;

    if (Number.isInteger(index)) {
      this.data.cur = index;
    } else {
      this.data.cur -= 1;
      if (this.data.cur < 0) this.data.cur = this.data.max;
    }

    this.dom.images.forEach((image, i) => {
      if (i !== this.data.last && i !== this.data.cur) gsap.set(image, { opacity: 0 });
    });


    let imgDur = getViewport().width < 768 ? 1.15 : 1.4;
    let tl = new gsap.timeline();

    // Image Animation
    tl.fromTo(this.dom.images[this.data.cur], imgDur,
      { scale: 1.2, xPercent: -100, zIndex: this.data.z, rotate: -25, opacity: 1 },
      { scale: 1, xPercent: 0, zIndex: this.data.z, rotate: 0, transformOrigin: "100% 100%", ease: Expo.easeInOut })
    tl.to(this.dom.images[this.data.last], imgDur, { xPercent: 100, rotate: 15, transformOrigin: "0% 0%", ease: Expo.easeInOut }, "<0.1")

    tl.to(this.dom.text[this.data.last + this.modify], 0.8, { autoAlpha: 0, ease: "sine.inOut", }, 0);
    tl.to(this.dom.text[this.data.cur + this.modify], 0.8, { autoAlpha: 1, ease: "sine.inOut", }, ">-.4");

    // Text Animation
    tl.to(this.dom.quotes[this.data.last], 0.8, { autoAlpha: 0, ease: "sine.inOut", }, 0);
    tl.to(this.dom.quotes[this.data.cur], 0.8, { autoAlpha: 1, ease: "sine.inOut", }, ">-.4");

    tl.to(this.dom.captions[this.data.last], 0.8, { autoAlpha: 0, ease: "sine.inOut", }, 0);
    tl.to(this.dom.captions[this.data.cur], 0.8, { autoAlpha: 1, ease: "sine.inOut", }, ">-.4");

    tl.add(() => { this.data.isTransitioning = false }, ">-0.3");

    this.updateDots();
    this.data.last = this.data.cur;
  }

  updateDots() {
    this.dom.dots.forEach(dot => {
      dot.classList.remove("is-selected")
    })

    this.dom.dots[this.data.cur].classList.add("is-selected")
  }

  clickDot(index) {
    if (index === this.data.cur) return

    if (index > this.data.cur) {
      this.next(index)
    } else {
      this.prev(index)
    }
  }
}